import { zodResolver } from '@hookform/resolvers/zod';
import React, { useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { z, ZodType } from 'zod';

type propsType<TSchema extends ZodType> = {
  children: React.ReactElement | React.ReactElement[];
  schema: TSchema;
  onSubmit: SubmitHandler<z.infer<TSchema> & Record<string, any>>;
  values?: Partial<z.infer<TSchema>>;
  onFormIntialized?: (
    methods: ReturnType<typeof useForm<z.infer<TSchema>>>
  ) => void;
};

export default function FormWrapper<TSchema extends ZodType>({
  children,
  onSubmit,
  schema,
  values,
  onFormIntialized,
}: propsType<TSchema>) {
  const methods = useForm<z.infer<TSchema>>({
    resolver: zodResolver(schema),
    mode: 'all',
    values,
  });

  // Expose methods to the parent of FormWrapper
  useEffect(() => {
    if (methods) onFormIntialized?.(methods);
  }, [methods, onFormIntialized]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
    </FormProvider>
  );
}
